import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { EmployeeContact, EmployeeContactCreate, EmployeeContactFilter } from '../data/employeeContact';

export function createEmployeeContactService(client: AxiosInstance) {
  return createCrudService<EmployeeContact, EmployeeContactCreate, EmployeeContactFilter>(
    client,
    '/hrm/EmployeeContact',
    'id',
  );
}

export type EmployeeContactService = CrudService<EmployeeContact, EmployeeContactCreate, EmployeeContactFilter>;
